import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import NoResultsUi from './../../../../shared/ui/NoResults';

import {
    BB_BETFEED_NO_RESULTS_TEXT,
    BB_BETFEED_NO_RESULTS_CLEAR_FILTERS_TEXT,
    GTM_BETFEED_CLEAR_FILTER_NO_RESULTS,
} from './../../constants';

const NoResults = (props) => {
    const [ t ] = useTranslation();
    const textContent = t(BB_BETFEED_NO_RESULTS_TEXT);
    let buttonLabel = t(BB_BETFEED_NO_RESULTS_CLEAR_FILTERS_TEXT);
    let onButtonClick = props.buttonClickHandler;

    if (!props.filtersSet) {
        buttonLabel = false;
    }

    return (
        <NoResultsUi onButtonClick={onButtonClick} buttonLabel={buttonLabel} gtmAttribute={GTM_BETFEED_CLEAR_FILTER_NO_RESULTS}>
            {textContent}
        </NoResultsUi>
    );
};

NoResults.propTypes = {
    buttonClickHandler: PropTypes.func.isRequired,
    filtersSet: PropTypes.bool.isRequired,
};

export default NoResults;
